{
  "de": {
    "proposal": {
      "actions": {
        "addDescription": "Beschreibung hinzufügen",
        "addDocuments": "Dokumente hinzufügen",
        "addSubchoiceList": "Unteroptionsliste hinzufügen",
        "addSubchoices": "Unteroption hinzufügen",
        "approve": "Annehmen",
        "cancel": "Abbrechen",
        "choice": {
          "collapse": "Optionen einklappen",
          "delete": "Option löschen",
          "edit": "Option bearbeiten",
          "expand": "Optionen ausklappen"
        },
        "choice_list": {
          "delete": "Optionsliste löschen"
        },
        "createNew": "Neues Angebot",
        "deleteDescription": "Beschreibung löschen",
        "deleteDocuments": "Dokumente entfernen",
        "delete_documents": "Dokument löschen | Dokumente löschen",
        "delete_proposal": "Angebot löschen",
        "delete_proposal_templates": "Angebotsvorlage löschen",
        "dontShare": "Noch nicht teilen",
        "duplicate": "Duplizieren",
        "edit": "Bearbeiten",
        "generatePDF": "PDF erstellen",
        "new": "Angebot",
        "newProposalCustomer": "Neues Angebot",
        "publish": "Veröffentlichen",
        "reject": "Genehmigung rückgängig machen",
        "save": "Speichern",
        "share": "Teilen",
        "shareWithProjectPartners": "Dokumente mit Projektpartnern teilen …",
        "share_units": "Mit Einheiten teilen",
        "signAndApprove": "Unterschreiben und Angebot genehmigen",
        "signElectronically": "Oder stattdessen elektronisch unterschreiben",
        "steps": {
          "collapse": "Schritte einklappen",
          "expand": "Schritte ausklappen"
        },
        "stop_template_sync": "Synchronisierung mit Vorlage beenden",
        "submit": "Absenden",
        "uploadAndApprove": "Hochladen und Angebot genehmigen",
        "uploadSignableDocument": "Unterschriebenes Dokument zur Genehmigung hochladen"
      },
      "attributes": {
        "amount_gross": "Bruttoangebot",
        "amount_net": "Nettoangebot",
        "choice_lists": {
          "description": "Beschreibung",
          "name": "Name"
        },
        "choices": {
          "description": "Beschreibung",
          "images": "Bilder",
          "name": "Name",
          "price_gross": "Artikelpreis brutto",
          "price_net": "Artikelpreis netto",
          "quantity": "Menge",
          "quantity_fixed": "Feste Menge",
          "quantity_max": "Maximum",
          "quantity_min": "Minimum",
          "quantity_not_fixed": "Kunde kann Menge selbst eingeben",
          "selected_default": "Immer ausgewählt",
          "total_price_gross": "Gesamt brutto",
          "total_price_net": "Gesamt netto"
        },
        "description": "Wie würden Sie dieses Angebot beschreiben?",
        "documents": "Dokumente hinzufügen",
        "name": "Name",
        "subtitle": "Das erleichtert es anderen, sich darauf zu beziehen",
        "title": "Geben Sie Ihrem Angebot einen Titel",
        "type": {
          "choices": "Optionsliste",
          "fixed": "Festpreisangebot"
        },
        "vat_percentage": "MwSt. %"
      },
      "labels": {
        "accepted": "Angenommen",
        "addExtraBudget": "Zusatzbudget hinzufügen",
        "allUnitsShared": "Diese Vorlage ist bereits mit allen Einheiten geteilt",
        "already_approved": "Dieses Angebot wurde bereits genehmigt.",
        "amount_net_total": "Nettoangebot gesamt",
        "amount_total": "Bruttoangebot gesamt",
        "approval_feedback": {
          "label": "Kommentar (optional)",
          "placeholder": "Teilen Sie Fragen, Bedingungen oder zusätzlichen Kontext mit dem Team."
        },
        "approve": "{name} genehmigen",
        "approved": "Genehmigt",
        "approvedDate": "Genehmigt am {date}",
        "ask_client_to_undo": "Sie können ein genehmigtes Angebot nicht bearbeiten. Wenden Sie sich zunächst an {client}, um die Genehmigung rückgängig zu machen.",
        "batchProposalsTemplate": "<p>Dieses Angebot wird für {units_count} Einheit(en) erstellt.</p></br><p>Da dieses Angebot für mehrere Einheiten erstellt wird, haben wir daraus eine Vorlage gemacht. Sie finden diese Vorlage unter dem Tab „Angebotsvorlagen“.</p></br><p>Vorlagen erleichtern das Bearbeiten oder Löschen aller Angebote, die mit dieser Vorlage geteilt werden.</p>",
        "batchProposalsWarning": "Dieses Angebot wird für {units_count} Einheiten erstellt. Wenn Sie später Änderungen daran vornehmen möchten, müssen Sie jedes einzeln bearbeiten.",
        "budget": "Budget",
        "builder": {
          "can_select_multiple": "Mehrfachauswahl möglich",
          "item": "Option hinzufügen",
          "multiple_choices_possible": "Mehrere Optionen möglich",
          "must_choose_item": "Option muss ausgewählt werden",
          "options": "Optionen",
          "section": "Optionsliste",
          "step": "Schritt",
          "step_basic": "Grundlegende Informationen",
          "step_details": "Details",
          "step_documents": "Dokumente",
          "step_internal": "Interne Informationen",
          "step_visibility": "Teilen mit"
        },
        "by": "von",
        "choice_lists": {
          "add_another": "Weitere Optionsliste hinzufügen",
          "create": "Optionslisten für das Angebot erstellen",
          "empty_help": "Beginnen Sie damit, Ihre erste(n) Optionsliste(n) hinzuzufügen. Optionslisten gruppieren Optionen für einen bestimmten Posten, z. B. „Bodenfliesen“. Nachdem Sie Optionslisten hinzugefügt haben, können Sie eine oder mehrere Optionen hinzufügen.",
          "selected": "Ausgewählt"
        },
        "choices": {
          "add_another": "Weitere Option hinzufügen",
          "create": "Optionen zu {choiceListName} hinzufügen",
          "optional": "optional",
          "selected_default": "Diese Option ist immer ausgewählt, und der Preis wird automatisch im Gesamtpreis berücksichtigt. Der Kunde kann diese Option nicht abwählen.",
          "selected_default_tooltip": "Diese Option ist immer enthalten, ihr Preis wird automatisch im Gesamtpreis berücksichtigt.",
          "subtotal": "Zwischensumme"
        },
        "clickToChangeVisibility": "Klicken, um die Sichtbarkeit zu ändern",
        "closed": "Diese Entscheidung ist jetzt geschlossen. Sie können kein Angebot mehr genehmigen.",
        "createProposal": "Angebot erstellen",
        "createProposals": "Angebot erstellen",
        "created": "Erstellt",
        "createdBy": "Erstellt von {uploader}",
        "customer": "Kunde",
        "customerHasNotSelectedYet": "Kunde hat noch nicht ausgewählt",
        "customer_name_confirm": "Schreiben Sie <i><b>{customerName}</b></i>, um dieses Angebot anzunehmen.",
        "customer_name_proceed": "Geben Sie <i><b>{customerName}</b></i> ein, um fortzufahren.",
        "customer_offer": "Kundenangebot",
        "customers": "Kunden",
        "decision_not_interested": "Die Entscheidung ist als „Kein Interesse“ markiert.",
        "definedPerUnit": "Pro Einheit festgelegt",
        "delete_proposal_template": "<p>Wenn Sie diese Vorlage löschen, werden auch alle synchronisierten Angebote gelöscht.<br>Wenn Sie das nicht möchten, verwenden Sie den Schalter unten.</p>",
        "depends_on_customer_input": "Abhängig von Kundeneingabe",
        "documentsRequireSignature": "Kunde muss Dokumente unterschreiben",
        "documents_shared_partners": "Nur die Dokumente des Angebots werden mit den Projektpartnern geteilt.",
        "duplicating": "Wird dupliziert",
        "edit": "Bearbeiten",
        "editNotAllowed": "Ein genehmigtes Angebot kann nicht bearbeitet oder gelöscht werden. Machen Sie die Genehmigung zunächst rückgängig, bevor Sie es bearbeiten.",
        "editProposal": "Angebot bearbeiten",
        "excl%VAT": "zzgl. {vat}% MwSt.",
        "exclVAT": "zzgl. MwSt.",
        "export_documents": "Dokumente exportieren",
        "extraBudget": "Zusatzbudget",
        "fractions_sent_count_header": "Angebot kann nicht erstellt werden!",
        "fractions_sent_count_message": "Für diese Entscheidung wurden bereits Raten versendet. Setzen Sie diese Raten zunächst auf den Status Entwurf zurück, um fortzufahren.",
        "full_prices": "Volle Preise verwenden. Ziggu erstellt automatisch Mehrpreise basierend auf dem Budget der Entscheidung.",
        "generatingPDF": "PDF wird erstellt",
        "has_requested_changes": "Für dieses Angebot liegt bereits eine offene Änderungsanfrage vor.",
        "hideDetails": "Details ausblenden",
        "installments_connected": "Mit diesem Angebot sind Raten verknüpft.",
        "internalNote": "Interne Notiz",
        "internalNoteSubtitle": "Diese Notiz ist nur für Sie und Ihr Team sichtbar.",
        "internal_info": "Interne Informationen",
        "keepHidden": "Verborgen halten",
        "keep_synced_proposals": "Synchronisierte Angebote beibehalten, damit sie zu eigenständigen Angeboten werden.",
        "link_to_template": "Mit Vorlage verknüpfen?",
        "link_to_template_after_create": "Dieses Angebot nach der Erstellung sofort mit der neuen Vorlage verknüpfen.",
        "makeDecision": "Nehmen Sie ein Angebot für {decision_name} an, indem Sie auf die Schaltfläche „Genehmigen“ klicken",
        "margin": "Marge",
        "marginBudget%": "Marge Budget ({margin}%)",
        "marginSurcharge%": "Marge Mehrpreise ({margin}%)",
        "marginSurchargesExtraBudget%": "Marge Zusatzbudget + Mehrpreise ({margin}%)",
        "new": "Neues Angebot",
        "noImage": "Kein Bild",
        "no_budget_available_yet": "Nicht zutreffend",
        "no_documents": "Das Angebot enthält keine Dokumente.",
        "no_edit_details": "Dieses Angebot enthält Elemente, die davon abhängen. Wenden Sie sich an den Auftraggeber, wenn Sie Details bearbeiten möchten.",
        "no_edit_details_installments": "Für dieses Angebot wurde mindestens eine Rate in Rechnung gestellt oder bezahlt. Um die Angebotsdetails zu bearbeiten, müssen Sie zunächst den Status dieser Rate auf „Erwartet“ ändern. Gehen Sie zu {link}.",
        "no_edit_details_installments_link": "Finanzen",
        "no_edit_documents": "Sobald ein Angebot genehmigt ist, können Dokumente nicht mehr bearbeitet werden.",
        "notApplicable": "Nicht zutreffend",
        "notDefined": "Nicht festgelegt",
        "notSeenYetByCustomer": "Vom Kunden noch nicht gesehen",
        "notSelectedYet": "Wählen Sie Ihre Optionen aus, um die Gesamtsumme zu sehen",
        "notSharedYet": "Noch nicht geteilt",
        "not_approved_yet": "Dieses Angebot ist noch nicht genehmigt.",
        "not_interested_reset_header": "Entscheidung als „Kein Interesse“ markiert",
        "not_interested_reset_message": "Diese Entscheidung ist derzeit als „Kein Interesse“ markiert. Beim Erstellen eines Angebots wird dieser Status zurückgesetzt.",
        "only_visible_team_partners": "Nur für das Team sichtbar",
        "other": "Sonstiges",
        "proposalFor": "Angebot für",
        "proposal_template_sync_note": "Änderungen an einer Angebotsvorlage aktualisieren alle synchronisierten (nicht genehmigten) Angebote.",
        "proposal_unapprove_not_possible": "Genehmigung kann nicht rückgängig gemacht werden",
        "proposalsApproved": "Genehmigte Angebote",
        "proposalsOther": "Andere Angebote",
        "relaunch": "Angebot neu starten",
        "request_changes": {
          "body": "Geben Sie an, was an diesem Angebot geändert werden muss",
          "feedback": "Feedback",
          "title": "Änderungen anfordern"
        },
        "requested_changes": "Änderungen angefordert",
        "requiresSignature": "Muss Dokumente unterschreiben",
        "seenByCustomer": "Vom Kunden gesehen:",
        "selectUnitsShare": "Einheiten auswählen, mit denen die Vorlage geteilt werden soll",
        "shareCustomerDescription": "Dieses Angebot ist mit einer Entscheidung verknüpft, die noch nicht mit dem Kunden geteilt wurde. Möchten Sie die Entscheidung ebenfalls teilen, damit der Kunde dieses Angebot sofort sehen kann?",
        "shareCustomerTitle": "Entscheidung mit Kunden teilen?",
        "shareDecision": "Entscheidung teilen",
        "shareExtraAlert": "Die Entscheidung wird ebenfalls geteilt, sobald Sie auf Senden klicken",
        "sharePartnerTitle": "Entscheidung mit Partner teilen?",
        "sharePartnersDescription": "Dieses Angebot ist mit einer Entscheidung verknüpft, die noch nicht mit dem Partner geteilt wurde. Möchten Sie die Entscheidung ebenfalls teilen, damit der Partner dieses Angebot sofort sehen kann?",
        "sharedWith": "Geteilt mit",
        "showAndEditDetails": "Details anzeigen und bearbeiten",
        "single_approval_warning": {
          "message": "Kontaktieren Sie Ziggu, um mehrere Angebotsgenehmigungen zu ermöglichen.",
          "title": "Sie können weiterhin Angebote erstellen, aber der Kunde kann nur ein Angebot genehmigen."
        },
        "skip_customer": "Das Projekt überspringt den Kundenschritt.",
        "surcharges": "Mehrpreise",
        "surcharges_extra": "Zusätzliche Mehrpreise",
        "synced_with_template": "Mit Angebotsvorlage synchronisiert",
        "synced_with_units": "Mit 1 Einheit synchronisiert | Mit {unit_count} Einheiten synchronisiert",
        "template_accept_confirm": "<p>Dieses Angebot ist mit einer Angebotsvorlage synchronisiert. Wenn Sie dieses Angebot annehmen, wird die Synchronisierung beendet, und dieses Angebot wird nicht mehr aktualisiert, wenn sich die Angebotsvorlage ändert.</p></br><p>Sind Sie sicher, dass Sie dieses Angebot annehmen möchten?</p>",
        "template_edit_confirm": "<p>Dieses Angebot ist mit einer Angebotsvorlage synchronisiert. Wenn Sie dieses Angebot bearbeiten, wird die Synchronisierung beendet, und dieses Angebot wird nicht mehr aktualisiert, wenn sich die Angebotsvorlage ändert.</p></br><p>Sind Sie sicher, dass Sie mit der Bearbeitung dieses Angebots fortfahren möchten?</p>",
        "totalBudget": "Gesamtbudget",
        "totalNetOffer": "Nettoangebot",
        "total_excl_vat": "Gesamt zzgl. MwSt.",
        "total_incl_vat": "Gesamt inkl. MwSt.",
        "total_vat": "MwSt. gesamt",
        "typeToShare": "Art des zu teilenden Angebots",
        "unit_not_activated": "Die Einheit ist nicht aktiviert.",
        "uploadDocuments": "Unterschriebene Dokumente hochladen",
        "uploadSignedDocument": "Oder stattdessen unterschriebenes Dokument hochladen",
        "vat_excl": "zzgl. MwSt.",
        "vat_excl_with_number": "zzgl. {vat}% MwSt.",
        "visibleForCustomer": "Für den Kunden sichtbar",
        "writeEmployeeNameAccept": "Schreiben Sie <i><b>{employeeName}</b></i>, um dieses Angebot anzunehmen.",
        "writeEmployeeNameDelete": "Schreiben Sie <i><b>{employeeName}</b></i>, um dieses Angebot zu entfernen.",
        "writeEmployeeNameReject": "Schreiben Sie <i><b>{employeeName}</b></i>, um die Genehmigung dieses Angebots rückgängig zu machen."
      },
      "placeholders": {
        "customers": {
          "none": {
            "subtitle": "Bald finden Sie hier ein Angebot zur Genehmigung",
            "title": "Noch keine Angebote für die Entscheidung {decision_name}"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Schlagen Sie ein oder mehrere Angebote vor und lassen Sie Ihren Kunden entscheiden.",
            "title": "Ein Angebot erstellen"
          },
          "proposalNotice": "Wichtig: Es kann nur 1 Angebot genehmigt werden. Sie können ein bestehendes Angebot jederzeit bearbeiten und neue Dokumente hinzufügen.",
          "template": {
            "subtitle": "Wenn Sie mehrere Angebote gleichzeitig erstellen, werden sie hier angezeigt",
            "title": "Es wurden noch keine Angebotsvorlagen erstellt."
          }
        },
        "partners": {
          "new": {
            "subtitle": "Schlagen Sie ein oder mehrere Angebote vor und lassen Sie den Kunden entscheiden.",
            "title": "Ein Angebot erstellen"
          },
          "proposalNotice": "Wichtig: Es kann nur 1 Angebot genehmigt werden. Sie können ein bestehendes Angebot jederzeit bearbeiten und neue Dokumente hinzufügen. Wenn ein Angebot bereits genehmigt wurde, kann ein Teammitglied dies rückgängig machen, bevor weitere Dokumente hinzugefügt werden."
        }
      },
      "toasts": {
        "convert": "Angebot wurde erfolgreich in eine Vorlage umgewandelt",
        "create": "Angebot wurde erfolgreich erstellt",
        "delete": "Angebot wurde erfolgreich gelöscht",
        "shareSuccess": "Angebote wurden erfolgreich geteilt",
        "update": "Angebot wurde erfolgreich aktualisiert"
      },
      "validation": {
        "amountNotUpdatable": "Der Betrag kann nicht aktualisiert werden: Einige Raten hängen davon ab",
        "choice_list": {
          "needChoice": "Diese Optionsliste benötigt mindestens 1 Option",
          "needSelection": "Für diese Option muss ein Element ausgewählt werden"
        },
        "choices": {
          "lessThanOrEqual": "Die Zahl muss kleiner oder gleich {max_number} sein",
          "needPriceItem": "Preis pro Stück ist erforderlich",
          "needSelection": "Auswahl einer Option erforderlich",
          "needVatPercentage": "MwSt.-Satz ist erforderlich",
          "quantityBetween": "Die Menge muss zwischen {quantity_min} und {quantity_max} liegen",
          "quantityNotZero": "Die Menge muss mindestens 1 betragen",
          "quantityRequired": "Menge ist erforderlich",
          "uniqueNames": "Namen müssen eindeutig sein"
        },
        "nameNotCorrect": "Der Name ist erforderlich und muss übereinstimmen",
        "needName": "Titel ist erforderlich",
        "needNumber": "Muss eine Zahl sein (z. B. 85)",
        "need_request_changes_note": "Geben Sie Feedback zu Ihrer Änderungsanfrage",
        "readAllDocuments": "Stellen Sie sicher, dass Sie alle Dokumente gelesen haben",
        "requiresSignature": "Markieren Sie mindestens 1 Dokument, das der Kunde elektronisch unterschreiben muss. Schalten Sie den Schalter unten aus, wenn keine Unterschriften benötigt werden.",
        "share": {
          "needSelection": "Wählen Sie jemanden aus, mit dem Sie das Angebot teilen möchten | Wählen Sie jemanden aus, mit dem Sie die Angebote teilen möchten",
          "needType": "Wählen Sie die Art(en) des Angebots aus"
        },
        "uploadAtLeast1Document": "Laden Sie mindestens 1 unterschriebenes Dokument hoch"
      }
    }
  }
}
